import { useEffect, useState } from "react";

import { CloudAlert } from "lucide-react";

import Logo from "src/components/icon/Logo";
import { SidebarProvider } from "src/components/ui/sidebar";

const PrerenderLoading = () => {
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimedOut(true);
    }, 15000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <SidebarProvider className="bg-background flex h-screen flex-col items-center justify-center gap-16">
      {!timedOut && <Logo noText className="size-20 animate-bounce" />}

      {timedOut && (
        <div className="text-foreground flex flex-col items-center gap-2">
          <span className="z-10 inline-flex items-center gap-4 text-xl font-bold">
            <CloudAlert className="text-destructive size-10" />
            Uh oh!
          </span>
          <p className="z-10">
            Something isn&apos;t working right. Please try again later or
            contact{" "}
            <a href={`mailto:${process.env.SUPPORT_EMAIL}`}>
              {process.env.SUPPORT_EMAIL}
            </a>
          </p>

          <Logo className="text-destructive absolute top-[5vh] w-[100vw] opacity-5" />
        </div>
      )}
    </SidebarProvider>
  );
};

export default PrerenderLoading;
